import { Badge } from "@/components/ui/badge";

import { statusChip, type ProposalStatus } from "../data/cockpit-data";
import { statusBadgeVariant } from "../format";

/**
 * A proposal's status, as a word.
 *
 * Meteoric paired each status with an icon AND a colour — a green tick, an
 * amber bang, a red cross. The icons are gone with the colours, and
 * deliberately: an icon is a second encoding of the same fact, and a tick that
 * is no longer green is just a tick. The status LABEL is the encoding that
 * survives every reader and every medium, and `statusChip` already returns it.
 */
export function StatusChip({ status }: { status: ProposalStatus }) {
  const chip = statusChip(status);
  return <Badge variant={statusBadgeVariant(chip.tone)}>{chip.label}</Badge>;
}
